import React from 'react'
import styled from 'styled-components'
import { Label as UnstyledLabel } from 'semantic-ui-react'
import { calculateColorContrastRatio } from 'libs/calculateColorContrastRatio'

const colorFontMap = {
  '#d3f8df': '#1e5d33', // green
  '#ffdde1': '#920111', // red
  '#ffefd5': '#664400', // yellow
  '#e6f2ff': '#003f80', // blue
  '#fefcd5': '#666100', // vanilla
}

// Define the styled component outside the functional component
const Label = styled(UnstyledLabel)`
  &.ui.label {
    background-color: ${({ color }) => color};
    color: ${({ fontColor }) => fontColor};
    border-color: ${({ color }) => color};
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: bottom;
  }
`

/**
 * @typedef {object} TagProps
 * @property {string} name
 * @property {string=} className
 * @property {string=} color
 * @property {string=} size
 * @property {boolean=} whiteFont
 *
 * @param {TagProps} props
 */
export function Tag({ name, className, color, size, whiteFont = false }) {
  const normalizedColor = color?.toLowerCase()
  const customFontColor = colorFontMap[normalizedColor] || null

  const white = '#fff'
  const black = '#555'
  const whiteIconContrastRatio = calculateColorContrastRatio(white, color)
  const blackIconContrastRatio = calculateColorContrastRatio(black, color)
  const fontColor = whiteIconContrastRatio > blackIconContrastRatio || whiteFont ? white : black

  return (
    <Label
      className={`basic mb1 ${className}`}
      size={size}
      color={color}
      fontColor={customFontColor || fontColor}
    >
      {name}
    </Label>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/Tag/index.js